import { render } from "./About.vue?vue&type=template&id=673ed242"
const script = {}
script.render = render

export default script